// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"68":"6cf6e995","325":"e2bbaa28","819":"b7de53eb","928":"d415850b"}[chunkId] + ".css";
};